import axios from 'axios';
export default function eCoachVMSApi(){

    const baseURL = axios.create({
        baseURL:process.env.REACT_APP_API_URL,
        headers:{
           'Access-Control-Allow-Origin': '*',
           'Access-Control-Allow-Headers': 'Content-Type, Authorization',
           'Access-Control-Allow-Methods': "GET,HEAD,POST,OPTIONS",
           "Content-Type": "application/json",
           "Access-Control-Max-Age": "86400",
       }
    });
    const getDropdwonOptions = async (type_name) => {
    try {
        const response = await baseURL.get('/getDropDown');
        const filteredData = response.data.find(item => item.type_name === type_name);
            if (filteredData) {
                return filteredData.type_elements;
            } else {
                console.error('No data found for type_name:', type_name);
                return [];
            }
        }catch (error) {
            console.error('Error fetching dropdown options:', error);
            throw error;
        }
    };
    
    return {
        getDropdwonOptions,
        baseURL,
    }
}